<template>
    <span>
        <product-hero></product-hero>
        <product-details></product-details>
        <page-footer></page-footer>
    </span>
</template>
<script>
import ProductHero from '@/components/ProductHero';
import ProductDetails from '@/components/ProductDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name: 'products',
    components: {
        ProductHero,
        ProductDetails,
        PageFooter
    }
};
</script>


